import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { getDeliveryAvailableAddresses } from '@vtex/delivery-packages/dist/address'

import { ROUTES } from '@/checkout-instore-legacy/constants/RoutesConstants'
import { ADDRESS_CARD_WIDTH } from '@/checkout-instore-legacy/shipping/constants'
import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import Button from '@/checkout-instore-legacy/components/Commons/Elements/Button'
import { animate } from '@/checkout-instore-legacy/utils/animation'
import { maskPostalCode } from '@/checkout-instore-legacy/shipping/utils'
import { addressShape } from '@/checkout-instore-legacy/shipping/shapes'
import { getVendor } from '@/checkout-instore-legacy/utils/vendorUtils'

let scrollContainer

export default function AvailableAddresses({
  availableAddresses,
  selectedAddresses,
  selectAddress,
  setShippingWasFilled,
  router,
}) {
  if (!availableAddresses) {
    return null
  }
  // incomplete addresses should not show as available
  availableAddresses = getDeliveryAvailableAddresses(availableAddresses)
  if (availableAddresses.length === 0) {
    return null
  }
  const vendor = getVendor()
  const storeName = vendor?.store?.name || '-'

  const scrollTo = (direction) => {
    const target = scrollContainer.scrollLeft + direction * ADDRESS_CARD_WIDTH

    animate({
      object: scrollContainer,
      prop: 'scrollLeft',
      target,
      duration: 0.25,
    })
  }

  const handleLeftScroll = () => {
    scrollTo(-1)
  }

  const handleRightScroll = () => {
    scrollTo(1)
  }
  return (
    <div id="available-addresses-shelf">
      <div className="bg-light-silver pt4 pb6">
        <div className="flex-auto-l pb4-l flex-l justify-between-l items-center-l pr5-l">
          <div>
            <div className="flex-auto-l pb4-l pt5-l flex-l justify-between-l items-center-l pr5-l mh5 mh6-ns mh6-l mv4-l pv5-ns pv4">
              <FormattedMessage id="shippingAvailableAddressesLabel" />
            </div>
          </div>
          <div className="dn flex-l items-baseline-l">
            <div>
              <Button
                size="xs"
                onClick={(e) => {
                  e.preventDefault()
                  handleLeftScroll()
                }}
              >
                <Icon type="arrowLeft" size={15} color="#c3c3c3" />
              </Button>
            </div>
            <div className="pl3-l">
              <Button
                size="xs"
                onClick={(e) => {
                  e.preventDefault()
                  handleRightScroll()
                }}
              >
                <Icon type="arrowRight" size={15} color="#c3c3c3" />
              </Button>
            </div>
          </div>
        </div>
        <div
          className="flex overflow-x-auto momentum hide-scrollbar"
          ref={(el) => {
            scrollContainer = el
          }}
        >
          {availableAddresses.map((address, index) => {
            const {
              receiverName,
              number,
              complement,
              country,
              postalCode,
              neighborhood,
              city,
              state,
              street,
            } = address
            let isSelected = false
            selectedAddresses.forEach((i) => {
              if (i.addressId === address.addressId) {
                isSelected = true
              }
            })
            return (
              <div
                id={`available-address-${index}`}
                className={`${
                  isSelected ? '' : ''
                }  dib f6 f4-ns f5-l lh-copy flex-none flex bg-base pointer bg-animate mh5 mh6-ns `}
                key={address.addressId}
                onClick={() => {
                  selectAddress(address)
                  setShippingWasFilled()
                  router.push(ROUTES.SHIPPING_SELECT_SLA)
                }}
              >
                <div className="flex-none pa3 pa4-ns tl">
                  <div className="flex-none pa3 pa4-ns">
                    <div className="lh-copy f5 f5-ns black mb3 mb5-ns">
                      <div
                        className="ph5 c-action-primary fw7"
                        aria-label="store-name"
                      >
                        {receiverName === 'isAnonymous'
                          ? storeName
                          : receiverName}
                      </div>
                    </div>
                    <div className="ph5 black">
                      {number !== '' ? (
                        <span>
                          {street}
                          {', '}
                          {number}
                          {complement !== '' && `, ${complement}`}
                          {' - '}
                          {neighborhood}
                        </span>
                      ) : (
                        <span>
                          {street}
                          {' - '}
                          {neighborhood}
                        </span>
                      )}
                    </div>
                    <div className="ph5 black">
                      {city}
                      {' - '}
                      {state}
                    </div>
                    <div className="ph5 black">
                      {maskPostalCode(postalCode)}
                      {' - '}
                      {country}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

AvailableAddresses.propTypes = {
  availableAddresses: PropTypes.arrayOf(addressShape),
  selectedAddresses: PropTypes.arrayOf(addressShape),
  selectAddress: PropTypes.func,
  setShippingWasFilled: PropTypes.func,
  router: PropTypes.any,
}
